/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import React from "react";
import styles from "./index.css";
import { getFeaturePolicyAllowList } from "./LMIframeSecurityUtils.js";

const LiquidModeIframe = ({ src, onLoad }) => (
  <iframe
    className={styles.iframe}
    src={src}
    onLoad={() => {
      onLoad();
    }}
    sandbox="allow-same-origin allow-scripts"
    data-testid="LiquidModeIframe"
    allow={getFeaturePolicyAllowList()}
  />
);

export default LiquidModeIframe;
